<template>
  <v-app>
    <v-app-bar color="primary" dark app>
      <v-app-bar-nav-icon
        v-if="member"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <v-toolbar-title>
        My Application
        <span class="teal--text text--lighten-5">(Beta)</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn
        large
        v-if="$store.state.loggedIn && $store.state.admin.boardMember"
        icon
        to="/guestslog"
      >
        <v-icon color="white">add</v-icon>
      </v-btn>-->
      <v-row class="padding-10" v-if="$store.state.user" justify="end">
        <v-btn
          large
          icon
          @click="
            showDialog = !showDialog;
            $refs.validateParkingForm.reset();
            alert.message = '';
          "
        >
          <v-icon color="white">search</v-icon>
        </v-btn>
        <v-btn v-if="$store.state.admin.super" large icon to="/requests">
          <v-badge overlap color="error">
            <template v-slot:badge>{{ adminRequests.length }}</template>
            <v-icon color="white">account_box</v-icon>
          </v-badge>
        </v-btn>
      </v-row>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" fixed temporary>
      <template v-slot:prepend>
        <v-list-item two-line>
          <v-list-item-avatar color="primary" dark small style="color: white">
            <v-icon color="white">person</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ $store.state.user.email }}</v-list-item-title>
            <v-list-item-subtitle>
              <v-btn text @click="signInOrOut">{{
                $store.state.user.email ? "Sign Out" : "Sign In"
              }}</v-btn>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item v-for="route in routes" :key="route.name" :to="route.path">
          <v-list-item-icon>
            <v-icon>{{ route.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ route.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-content>
      <v-container fluid>
        <router-view
          v-if="
            $route.name == 'Sign In' ||
            $route.name == 'Sign Up' ||
            $store.state.loggedIn ||
            this.loggedIn
          "
        ></router-view>
        <v-row v-else justify="center" align="center">
          <v-col cols="12" lg="4">
            <router-link to="/signin">Sign In</router-link>
          </v-col>
        </v-row>
        <v-dialog :value="showDialog" max-width="700px">
          <v-form ref="validateParkingForm">
            <v-card class="padding-20">
              <v-card-title>Validate Parking</v-card-title>
              <v-row justify="center">
                <v-col cols="10" lg="6">
                  <v-text-field
                    append-icon="search"
                    v-model="licensePlate"
                    label="Enter License Plate"
                    max-width="100px"
                    dense
                    outlined
                    @keyup.enter="validateParking"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="10">
                  <v-alert
                    v-if="alert.message != ''"
                    :type="alert.type"
                    :color="alert.type"
                    outlined
                    >{{ alert.message }}</v-alert
                  >
                </v-col>
              </v-row>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text color="error" @click="showDialog = false"
                  >CLOSE</v-btn
                >
                <v-btn text color="primary" @click="validateParking"
                  >VALIDATE</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </v-container>
    </v-content>
    <v-footer app></v-footer>
  </v-app>
</template>

<script>
import { adminsRef, membersRef } from "./firebaseApp";
import permissionsObject from "./components/json/roles_permissions.json";

export default {
  name: "App",
  data: () => ({
    drawer: null,
    routes: [],
    member: {},
    admin: {},
    admins: [],
    licensePlate: "",
    userRole: "",
    loggedIn: false,
    adminRequests: [],
    permissions: permissionsObject,
    alert: {
      message: "",
      type: "error",
    },
    showDialog: false,
  }),
  watch: {
    "$store.state.admin": function () {
      this.admin = this.$store.state.admin;
      if (this.admin.boardMember && this.admin.superVerified)
        this.userRole = "boardMember";
      else if (this.admin.towingCompany && this.admin.superVerified) {
        this.userRole = "towingCompany";
      } else if (this.admin.super && this.admin.superVerified) {
        this.userRole = "super";
      } else this.userRole = "member";
      if (this.admin.super) this.loadAdmins();
      this.loadRoutes();
    },
    "$store.state.member": function () {
      this.loadRoutes();
    },
    $route(to) {
      if (this.userRole == "towingCompany") {
        this.$router.push("/visitorslog");
      } else if (
        this.permissions != undefined &&
        to.name != "No Permissions" &&
        !this.permissions[this.userRole].routes.includes(to.name) &&
        !this.admin.super
      )
        this.$router.push("/nopermissions");
    },
  },
  methods: {
    signInOrOut() {
      if (this.$store.state.user) {
        this.$store.dispatch("signOut");
        this.routes = [];
        this.$router.push("/signin");
      } else {
        this.$router.push("/signin");
      }
    },
    loadAdmins() {
      let admins = [];
      if (this.admin.super) {
        adminsRef.once("value", (snap) => {
          admins = [];
          snap.forEach((admin) => {
            let adminObject = {};
            adminObject = admin.val();
            adminObject.id = admin.key;
            admins.push(adminObject);
          });
          this.admins = admins;
          this.loadRequests(admins);
          this.$store.dispatch("setAdmins", admins);
        });
      }
    },
    validateParking() {
      let licensePlate = this.licensePlate,
        foundMatch = false;
      membersRef.on("value", (snap) => {
        snap.forEach((member) => {
          var memberLicensePlate = member
            .val()
            .licensePlate.toLowerCase()
            .replace(/[-\s]/g, "");
          var inputLicensePlate = licensePlate
            .toLowerCase()
            .replace(/[-\s]/g, "");
          if (memberLicensePlate == inputLicensePlate) {
            foundMatch = true;
            var expirationDate =
              member.val().expirationDate != ""
                ? new Date(member.val().expirationDate)
                : "";
            var today = new Date();
            if (
              member.val().guest &&
              (expirationDate == "" || expirationDate < today)
            ) {
              this.alert.type = "error";
              this.alert.message = "This visitor is registered, but not active";
            } else if (member.val().guest && expirationDate > today) {
              (this.alert.type = "success"),
                (this.alert.message = "Registered and active visitor");
            } else {
              (this.alert.type = "error"), (this.alert.message = "Resident");
            }
          }
        });
        if (!foundMatch) {
          this.alert.type = "error";
          this.alert.message =
            "This License Plate is not registered in our system";
        }
      });
    },
    loadRoutes() {
      this.routes = [];
      this.$router.options.routes.forEach((route) => {
        this.userRole = this.userRole == "" ? "member" : this.userRole;
        var userRoutes = this.permissions[this.userRole].routes;
        if (
          userRoutes.includes(route.name) &&
          route.name != "Sign Up" &&
          route.name != "Sign In" &&
          route.name != "Project"
        ) {
          if (route.name == "My Community") {
            var communityCode = this.admin.communityCode;
            this.routes.push({
              name: route.name,
              icon: route.icon,
              path: `/community/${communityCode}`,
            });
          } else {
            this.routes.push({
              name: route.name,
              icon: route.icon,
              path: route.path,
              params: route.params,
            });
          }
        }
      });
    },
    loadRequests(admins) {
      let requests = [];
      admins.forEach((admin) => {
        if (!admin.superVerified) {
          requests.push(admin);
        }
      });
      this.adminRequests = requests;
    },
  },
  mounted() {
    let user = JSON.parse(sessionStorage.getItem("user"));
    if (user != undefined) {
      this.loggedIn = true;
      this.$store.dispatch("signIn", user);
      let member = JSON.parse(sessionStorage.getItem("member"));
      if (member != undefined) {
        this.$store.dispatch("setMember", member);
      }
      let admin = JSON.parse(sessionStorage.getItem("admin"));
      if (admin != undefined) {
        this.$store.dispatch("setAdmin", admin);
      }
    }
  },
  created() {
    if (this.$route.name == null) {
      this.$router.push("/signin");
    }
  },
};
</script>
